import React from 'react';
import styled from 'styled-components';

const StyledCopyright = styled.div`
  font-size: 12px;
  text-align: center;
`;

export default () =>
  <StyledCopyright>
    <p>Copyright © 2017 Hauser & Wirth.</p>
    <p>Alle Rechte vorbehalten.</p>
  </StyledCopyright>;



// WEBPACK FOOTER //
// ./src/components/Copyright.js